export const getSingleOrdersDiscountValue = (singleOrdersDiscount, numOfTickets) => {
  if (!singleOrdersDiscount?.length) return 0;
  const activeDiscount = singleOrdersDiscount.find(
    (od) => od.isActive && od.numOfTickets === numOfTickets && od.discountValueType === 'FIXED_AMOUNT',
  );
  if (!activeDiscount) return 0;
  return activeDiscount.discountValue / 100;
};

export const getSingleOrdersDiscountData = (singleOrdersDiscount, numOfTickets) => {
  if (!singleOrdersDiscount?.length) {
    return { temporaryDiscountAmount: 0, temporaryDiscountLabel: null, hideFullPrice: false };
  }
  const activeDiscount = singleOrdersDiscount.find(
    (od) => od.isActive && od.numOfTickets === numOfTickets && od.discountValueType === 'FIXED_AMOUNT',
  );
  if (!activeDiscount) {
    return { temporaryDiscountAmount: 0, temporaryDiscountLabel: null, hideFullPrice: false };
  }
  return {
    temporaryDiscountAmount: activeDiscount.discountValue / 100,
    temporaryDiscountLabel: activeDiscount.label,
    hideFullPrice: !!activeDiscount.hideFullPrice,
  };
};

export const getSubscriptionDiscountValue = (subscriptionsDiscount, cost) => {
  if (!subscriptionsDiscount?.length) return 0;
  const activeDiscount = subscriptionsDiscount.find(
    (sd) => sd.isActive && sd.totalCost === cost * 100 && sd.discountValueType === 'FIXED_AMOUNT',
  );
  if (!activeDiscount) return 0;
  return activeDiscount.discountValue / 100;
};
